@if (previousUserId() !== currentMessage().authorId) {
  <div class="task-view-comment-item__left">
    <ux-avatar class="task-view-comment-item__avatar" [user]="currentMessage().invite?.user"> </ux-avatar>
  </div>
}
<div
  class="task-view-comment-item__right"
  [ngClass]="{
    'task-view-comment-item__right_short': previousUserId() === currentMessage().authorId,
  }"
>
  <div class="task-view-comment-item__header">
    <div
      class="task-view-comment-item__user"
      [ngClass]="{
        'task-view-comment-item__user_my': userId === currentMessage().authorId,
      }"
    >
      {{ currentMessage().invite?.user.firstName }} {{ currentMessage().invite?.user.lastName }}
    </div>

    <div class="task-view-comment-item__header-right">
      <div class="task-view-comment-item__time">
        {{ currentMessage().createdAt | date: 'd MMM H:mm' }}
      </div>
      <div
        class="task-view-comment-item__like"
        [ngClass]="{ 'task-view-comment-item__like_active': currentMessage().isLike }"
        (click)="onLike()"
      >
        <div class="task-view-comment-item__like-count">
          {{ currentMessage().likes.length ? currentMessage().likes.length : '' }}
        </div>
        <i class="icon-like task-view-comment-item__like-icon"></i>
      </div>

      <div class="task-view-comment-item__menu">
        <i class="icon-more-v task-view-comment-item__menu-icon" (click)="onToggleMenu()"></i>

        @if (isShowMenu()) {
          <ux-context-menu
            class="task-view-comment-item__context-menu"
            (clickOutside)="onCloseMenu()"
            [delayClickOutsideInit]="true"
            (click)="onCloseMenu()"
          >
            <ux-context-menu-item
              menu1
              icon="icon-plus-circle"
              [name]="currentMessage().isPin ? 'Открепить' : 'Закрепить'"
              (click)="onPin()"
            >
            </ux-context-menu-item>
            @if (currentMessage().canUpdate) {
              <ux-context-menu-item menu1 icon="icon-edit-2" name="Редактировать" (click)="onEdit()">
              </ux-context-menu-item>
            }
            @if (currentMessage().canUpdate) {
              <ux-context-menu-item
                menu1
                icon="icon-trash"
                [name]="!deleteConfirm() ? 'Удалить' : 'Вы уверены?'"
                (click)="onDelete()"
              >
              </ux-context-menu-item>
            }
          </ux-context-menu>
        }
      </div>
    </div>
  </div>
  <div class="task-view-comment-item__body">
    @if (currentMessage().time) {
      <div class="task-view-comment-item__spent-time-wrapper">
        <i class="icon-time task-view-comment-item__spent-time-icon"></i>
        <span class="task-view-comment-item__spent-time">{{ currentMessage().time }} ч.</span>
      </div>
    }
    <div class="task-view-comment-item__message" [innerHTML]="currentMessage().message"></div>
    <!--<app-task-view-comment-link-preview class="task-view-comment-item__link-preview"></app-task-view-comment-link-preview>-->

    @if (files().length) {
      <div class="task-view-comment-item__files">
        @for (file of files(); track file) {
          <ux-preview-file
            [file]="file"
            (deleteFile)="onDeleteFile($event)"
          ></ux-preview-file>
        }
      </div>
    }

    @if (images().length) {
      <div class="task-view-comment-item__images">
        @for (column of images(); track column) {
          <div class="task-view-comment-item__images-column">
            @for (image of column; track image) {
              <img (click)="imageService.open(image)" [src]="image | imagePreview" />
            }
          </div>
        }
      </div>
    }
  </div>
</div>
